import { render, staticRenderFns } from "./QueryVue.vue?vue&type=template&id=24206326&scoped=true&"
import script from "./QueryVue.vue?vue&type=script&lang=js&"
export * from "./QueryVue.vue?vue&type=script&lang=js&"
import style0 from "./QueryVue.vue?vue&type=style&index=0&id=24206326&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24206326",
  null
  
)

export default component.exports